let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("icT1H")).then(() => parcelRequire('1a85K'));